import { redirect } from "react-router-dom";

export function action() {
  localStorage.removeItem("token");
  localStorage.removeItem("expiration");
  localStorage.removeItem("userName");
  localStorage.removeItem("photoURL");
  localStorage.removeItem("userData");
  return redirect("/");
}
